/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const USERGETEDUCATIONSBYUSERID= createAsyncThunk(
  "usergetEducationsByUserId/usergetEducationsByUserId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const usergetEducationsByUserIdSlice = createSlice({
  name: "usergetEducationsByUserIdSlice",
  initialState: {
    usergetEducationsByUserId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfusergetEducationsByUserId: (state) => {
        state.usergetEducationsByUserId.loading = false
        state.usergetEducationsByUserId.error = false
        state.usergetEducationsByUserId.data = []
        state.usergetEducationsByUserId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(USERGETEDUCATIONSBYUSERID.fulfilled, (state, action) => {
      state.usergetEducationsByUserId = {
        ...state.usergetEducationsByUserId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(USERGETEDUCATIONSBYUSERID.pending, (state, action) => {
      state.usergetEducationsByUserId = {
        ...state.usergetEducationsByUserId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(USERGETEDUCATIONSBYUSERID.rejected, (state, action) => {
      state.usergetEducationsByUserId = {
        ...state.usergetEducationsByUserId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const usergetEducationsByUserIdAction = {
    USERGETEDUCATIONSBYUSERID,
};

export { usergetEducationsByUserIdAction };
export default usergetEducationsByUserIdSlice.reducer;
export const {setInitialStateOfusergetEducationsByUserId} = usergetEducationsByUserIdSlice.actions